import cn from "classnames";

import { Typography } from "shared/ui/components/Typography";

import styles from "./CalculatorFormControl.module.scss";

const VARIANTS: { [key: string]: string } = {
  vertical: styles.controlVertical,
  horizontal: styles.controlHorizontal,
};

const CalculatorFormControl = ({
  className,
  errorClassName,
  children,
  required,
  withVerticalSpace = true,
  haveError,
  error,
  variant = "vertical",
  label,
  labelProps,
}: any) => (
  <>
    <label
      className={cn(
        styles.control,
        {
          [styles.controlWithSpace]: withVerticalSpace,
          [styles.controlError]: haveError
        },
        VARIANTS[variant],
        className
      )}
    >
      {label && (
        <Typography
          className={cn(
            styles.label,
            { [styles.labelRequired]: required }
          )}
          variant="bodyM"
          {...labelProps}
        >
          {label}
        </Typography>
      )}
      {children}
    </label>
    {haveError && error && (
      <div className={cn(styles.error, errorClassName)}>
        <Typography className={styles.errorText} variant="bodyXS">
          {error}
        </Typography>
      </div>
    )}
  </>
);

export default CalculatorFormControl;
